// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/WindowPopUp/Selectqr.css
// module id = 2352
// module chunks = 0